<h3>Modify Release Note</h3>
<app-release-note-editor
  [releaseNote]="existingReleaseNote"
  (makeSubmit)="onSubmit($event)"
  (cancelSubmit)="cancel($event)"
></app-release-note-editor>
